import { createFileRoute } from "@tanstack/react-router";
import Portfolio from "@/pages/Portfolio";
import { portfolioHead } from "@/lib/route-seo";

export const Route = createFileRoute("/portfolio")({
  head: () => portfolioHead(),
  component: Portfolio,
});
